// extracted by mini-css-extract-plugin
export default {"eventcal":"Header_eventcal__3QLNG","style":"Header_style__quhiG","active":"Header_active__4J+yv","tabheader":"Header_tabheader__EHkv8","logo":"Header_logo__GM8lO"};